
class CollectionProductGrid extends HTMLElement {
  constructor() {
    super();

    // Get 'this' data
    this.products = this.querySelectorAll('[data-collection-product]');
    this.mainCollectionProductGrid = this.querySelector('#main-collection-product-grid');

    // Get 'banner' data
    this.collectionColumnBanners = document.querySelector('[data-collection-column-banners]');
    this.sectionId = this.collectionColumnBanners?.dataset.sectionId;
    this.collectionColumnBanner = document.querySelectorAll('[data-collection-column-banner');

    this.fetchSection();    
  }

  fetchSection() {    
    // Fetch from url
    fetch(`?section_id=${this.sectionId}`)
      .then(response => response.text())
      .then(text => {
        const html = new DOMParser().parseFromString(text, 'text/html');

        this.collectionColumnBanner.forEach(columnBanner => {
          this.bannerPositions = columnBanner.dataset.columnBannerPosition.replace(/\s/g, '');
          this.bannerPositionsArr = this.bannerPositions.toString().split(',');

          this.bannerPositionsArr.forEach(bannerPosition => {
            const position = bannerPosition - 1;
            this.products[position].before(columnBanner.cloneNode(true));
          });
        });
      })
      .catch(e => {
        console.error(e);
      });
  }
}

if (!customElements.get('collection-product-grid')) {
  customElements.define('collection-product-grid', CollectionProductGrid);
}